import React from 'react';
import ReactPlayer from 'react-player';

const Scenario4Video5 = () => {
    return (
        <div className='Scenario1VideoWrap Scenario1Video3'>
            <ReactPlayer url='https://youtu.be/Nu5q_d8speg' controls={true} />
        </div>
    );
}

export default Scenario4Video5;